import * as React from "react";

import { cn } from "@/lib/utils";
import { Input } from "@/components/ui/input";

interface DatePickerProps extends Omit<
  React.InputHTMLAttributes<HTMLInputElement>,
  "value" | "onChange" | "onBlur"
> {
  /** Value as YYYY-MM-DD string */
  value?: string | null;
  /** Called with YYYY-MM-DD string or empty string */
  onChange?: (value: string) => void;
  onBlur?: () => void;
  placeholder?: string;
  disabled?: boolean;
  className?: string;
  id?: string;
}

export const DatePicker = React.forwardRef<HTMLInputElement, DatePickerProps>(
  ({ value, onChange, onBlur, disabled, className, id, ...props }, ref) => {
    return (
      <Input
        ref={ref}
        id={id}
        type="date"
        lang="de-CH"
        value={value ?? ""}
        onChange={(e) => onChange?.(e.target.value)}
        onBlur={onBlur}
        disabled={disabled}
        className={cn("native-date-input", className)}
        {...props}
      />
    );
  },
);
DatePicker.displayName = "DatePicker";
